<template>
    <ModalWrapper v-model="modal" :fullscreen="isMobile" width="500">
        <template v-slot:activator>
            <v-btn color="primary" data-cy="add" @click="modal = true">
                {{ $t('add') }}
            </v-btn>
        </template>
        <template v-slot:title>
            {{ $t('attachments') }}
        </template>
        <template v-slot:content>
            <v-list>
                <v-list-item class="px-0">
                    <div class="mb-4">{{ $t('select_the_document_you_want_to_upload') }}</div>
                    <div class="d-md-flex align-md-center">
                        <v-file-input
                            v-model="file"
                            label="File input"
                            truncate-length="20"
                            show-size
                            density="compact"
                            data-cy="file-input"
                            class="mr-0 mr-md-5"
                            hide-details
                        />
                        <v-btn
                            :block="isMobile"
                            :class="{'mt-6': isMobile}"
                            :loading="isLoading"
                            :disabled="!file || isLoading"
                            color="primary"
                            variant="flat"
                            data-cy="upload-document"
                            @click="uploadDocument"
                        >
                            {{ $t('upload') }}
                        </v-btn>
                    </div>
                </v-list-item>
                <v-list-item class="px-0">
                    <v-select
                        v-model="processId"
                        :menu-props="{bottom: true, offsetY: true}"
                        :items="hideCancelledServices ? filteredServices : services"
                        :label="$t('relates_to')"
                        item-title="name"
                        item-value="value"
                        density="compact"
                        hide-details
                        variant="outlined"
                        data-cy="relates-to"
                        class="py-2"
                    />
                </v-list-item>
                <v-list-item v-if="filteredServices.length" density="compact" class="px-0">
                    <v-checkbox
                        v-model="hideCancelledServices"
                        :label="$t('hide_cancelled_services')"
                        hide-details
                        class="ml-auto width-max-content"
                        data-cy="hide-cancelled-services"
                        @update:model-value="processId = null"
                    />
                </v-list-item>
                <v-list-item v-if="isTO1" class="px-0">
                    <div class="">{{ $t('visible_for') }}</div>
                    <v-radio-group v-model="visibleForAll" inline color="primary" density="compact" hide-details>
                        <v-radio :label="$t('for_all')" :value="true" class="mr-2" data-cy="visible-for-all" />
                        <v-radio
                            :label="$t('for_to1_only')"
                            :value="false"
                            class="mr-2"
                            data-cy="visible-for-to1-only"
                        />
                    </v-radio-group>
                </v-list-item>
            </v-list>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {blobToBase64} from '@/utils/helpers'

    @Component({
        components: {},
    })
    export class ServiceDocumentsModal extends Vue {
        @Prop({required: true}) orderId
        @Prop({required: true}) companyId
        @Prop({required: true}) orderServices
        modal = false
        isLoading = false
        file = null
        services = []
        filteredServices = []
        hideCancelledServices = true
        processId = null
        visibleForAll = false

        mounted() {
            const itemsByServices = this.orderServices.map(e => ({
                name: e.serviceName,
                value: e.processId,
                status: e.status,
            }))
            this.services = [{name: this.$t('reservation'), value: null, status: null}, ...itemsByServices]
            this.filteredServices = this.services.filter(
                service => service.status && service.status.toLowerCase() !== 'canceled'
            )
        }

        async uploadDocument() {
            this.isLoading = true
            const base64 = await blobToBase64(this.file)
            const encodedData = base64.split('base64,')[1]
            const contentType = base64.split(';base64,')[0].split('data:')[1]
            const data = {
                orderId: this.orderId,
                companyId: this.companyId,
                creator: {
                    id: authStore.user.person.personId,
                    firstName: authStore.user.person.firstName,
                    lastName: authStore.user.person.lastName,
                },
                name: this.file.name,
                encodedData,
                contentType,
                documentType: 'OTHER',
                processId: this.processId,
                visibleForAll: this.isTO1 ? this.visibleForAll : true,
            }

            try {
                await this.$api.documents.post(data)
                this.$emit('updateDocument')
                this.file = null
                this.modal = false
            } catch (e) {
                this.$toast.error(this.$t('error_message.something_went_wrong'))
            }
            this.isLoading = false
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default ServiceDocumentsModal
</script>
